import { render, staticRenderFns } from "./UICursor.vue?vue&type=template&id=d621640a&"
import script from "./UICursor.vue?vue&type=script&lang=ts&"
export * from "./UICursor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports